import { MiddlewareStore } from "store/createStore";
import { IChatMessage } from "store/messages/messages.state";
import { setAttachmentStatus } from "store/messages/messages.actions";
import * as Logger from '../../../../../services/logger'

export const saveAttachmentId = async (store: MiddlewareStore, message : IChatMessage) => {
    
    try {
        const { contactId, connectionDetails } = store.getState().app;
        const attachmentId = message.attachments?.[0]?.AttachmentId;
        if (!attachmentId) throw new Error('unable to retrieve attachment id');

        const { contactFlowId } = connectionDetails;
        const localAttachmentsPath = `smartagent_signed_attachment_ids/${contactFlowId}`;
        const localAttachmentsIds = localStorage.getItem(localAttachmentsPath);

        if (!localAttachmentsIds)
            throw new Error('unable to retrieve attachment ids from storage');
        const attachmentConfig = JSON.parse(localAttachmentsIds);

        const attachment = await window.bchat.getAttachment({
            contactId: contactId!,
            attachmentID: attachmentId,
        });

        if(!attachment) throw new Error('unable to get attachment key')

        const s3Key = attachment.Url.match('(?<=[a-z-A-Z]/)(.*?)(?=\\?)')?.[0];

        if (!(contactId && attachmentConfig[contactId]))
            throw new Error('unable to find contact Id in attachment');
        attachmentConfig[contactId].push(s3Key);
        localStorage.setItem(localAttachmentsPath, JSON.stringify(attachmentConfig));
    } catch (error) {
        Logger.error('Unable to formulate attachment ids', error)
        console.log('error occured when trying to formulate attachment IDs', error);
    }
}

const mapAttachmentStatus = (status?: connect.AttachmentItem["Status"]) => {
    switch(status) {
        case 'APPROVED' :
            return 'success'
        case 'REJECTED' :
            return 'virus'
        case 'IN_PROGRESS' :
            return 'uploading'
        default :
            return 'default'
    }
}

export const handleAttachment = async (message: IChatMessage, store: MiddlewareStore, session: connect.CustomerChatSession, discard = true) => {

    if (message.type !== 'ATTACHMENT' || !message.attachments?.length) return message

    saveAttachmentId(store, message)

    let currentAttachment

    if(message.role === 'CUSTOMER') {
        const attachmentStatus = mapAttachmentStatus(message.attachments[0].Status)

        const pendingAttachments = store.getState().app.pendingAttachments

        currentAttachment = pendingAttachments.find(attachment => 
            attachment.name === message.attachments?.[0].AttachmentName && 
            attachment.type === message.attachments?.[0].ContentType)
            
        if(currentAttachment) {
            store.dispatch(setAttachmentStatus(attachmentStatus, currentAttachment.id))
        }

        if (attachmentStatus === 'virus') {
            message.content = {
                type: 'FILE_LINK',
                src: '',
                label: message.attachments[0].AttachmentName,
                fileType: '',
                status: 'virus',
            }
            if (discard) {
                message.discarded = true;
            }
            return message
        }
    }

    try {
        const file = await session.downloadAttachment({ 
            attachmentId: message.attachments[0].AttachmentId 
        });
        const url = window.URL.createObjectURL(file)

        message.content = {
            type: 'FILE_LINK',
            src: url,
            label: message.attachments[0].AttachmentName,
            isImage: file.type.split('/')[0] === 'image',
            fileType: file.type,
            status: 'success',
            shouldDownload: true,
            onDownload: () => {
                const downloadLink = document.createElement('a')
                downloadLink.setAttribute('download', message.attachments?.[0]?.AttachmentName ?? 'Download')
                downloadLink.setAttribute('href', url)
                document.body.appendChild(downloadLink)
                downloadLink.click()
                downloadLink.remove()
            },
        }
    } catch (error) {
        console.error('Failed to download attachment:', error)
        
        message.content = {
            type: 'FILE_LINK',
            src: '',
            fileType: '',
            label: message.attachments[0].AttachmentName,
            status: 'failed',
        }
        
        if (message.role === 'CUSTOMER' && currentAttachment) {
            store.dispatch(setAttachmentStatus('failed', currentAttachment.id))
        }
    }

    if (message.role === 'CUSTOMER' && discard) {
        message.discarded = true;
    }

    return message;
}